__turbopack_context__.v({
  "abstract-video-player": "abstract-video-player-component-module-scss-module__r2-58a__abstract-video-player",
});
